import { createSlice } from "@reduxjs/toolkit";

import {
  getDivisionTiersAction,
  getDivisionTiersMeAction,
  getListDivisionTiersRewardsAction,
  nftRewardAction,
  getDivisionTiersHistoryAction
} from "./divisions.action";

const initialState = {
  isLoading: false,
  isLoadingRules: false,
  error: {},
  listDivisionTiersRewards: {
    items: [],
    limit: 10,
    page: 1,
    totalCount: 0,
    totalPage: 0,
  },
  divisionMe: {},
  divisionTiers: {},
  divisionTiersHistory: {
    items: [],
    limit: 10,
    page: 1,
    totalCount: 0,
    totalPage: 0,
  },
};

const { actions, reducer } = createSlice({
  name: "divisions_slice",
  initialState,
  reducers: {
    resetDivisionTiersRewardsAction: (state) => {
      state.listDivisionTiersRewards = initialState.listDivisionTiersRewards;
      state.error = initialState.error;
      state.isLoading = initialState.isLoading;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListDivisionTiersRewardsAction.pending, (state) => {
        state.isLoadingRules = true;
      })
      .addCase(getListDivisionTiersRewardsAction.fulfilled, (state, action) => {
        state.isLoadingRules = false;
        state.listDivisionTiersRewards = {
          items: action.payload.data,
          limit: action.payload.limit,
          page: action.payload.page,
          totalCount: action.payload.totalCount,
          totalPage: action.payload.totalPage,
        };
      })
      .addCase(getListDivisionTiersRewardsAction.rejected, (state, action) => {
        state.isLoadingRules = false;
        state.error = action.payload.error;
      })

      .addCase(nftRewardAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(nftRewardAction.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(nftRewardAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.error;
      })

      .addCase(getDivisionTiersAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDivisionTiersAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.divisionTiers = action.payload.data;
      })
      .addCase(getDivisionTiersAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.error;
      })

      .addCase(getDivisionTiersMeAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDivisionTiersMeAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.divisionMe = action.payload.data;
      })
      .addCase(getDivisionTiersMeAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      
      .addCase(getDivisionTiersHistoryAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDivisionTiersHistoryAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.divisionTiersHistory = {
          items: action.payload.data,
          limit: action.payload.limit,
          page: action.payload.page,
          totalCount: action.payload.totalCount,
          totalPage: action.payload.totalPage,
        };
      })
      .addCase(getDivisionTiersHistoryAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.error;
      });
  },
});

export { reducer };
export default actions;
